import { css } from '@emotion/react';
import { AppointmentType } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/appointment_type.pb';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

type AppointmentTypeCardProps = {
  appointmentTypeDetails: AppointmentType;
};

export const AppointmentTypeChip = ({ appointmentTypeDetails }: AppointmentTypeCardProps) => {
  return (
    <div css={chipStyles}>
      {appointmentTypeDetails?.details?.clr && <div css={dotStyles} />}
      <Text size='small' color='light'>
        {appointmentTypeDetails.displayName || appointmentTypeDetails.externalName}
      </Text>
    </div>
  );
};

const chipStyles = css({
  background: theme.colors.neutral5,
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.borderRadius.small,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
});

const dotStyles = css({
  background: 'appointmentTypeDetails?.details?.clr',
  width: theme.spacing(1),
  height: theme.spacing(1),
  borderRadius: theme.borderRadius.full,
});
